import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import PageLoading from '@/components/Loaders/PageLoading';
import { saveEmbedLoading } from '@/features/embedLoading/embedLoadingSlice';
import { Chat } from '@/pages';

const EmbedWrapper = () => {
  const dispatch = useDispatch();
  const [showLoader, setShowLoader] = useState(true);
  const imageLoading = useSelector((state) => state.embedLoading.embedLoading);

  useEffect(() => {
    dispatch(saveEmbedLoading(true));
    return () => {};
  }, [dispatch]);

  useEffect(() => {
    setShowLoader(imageLoading);
  }, [imageLoading]);

  return (
    <>
      <PageLoading loading={showLoader} />
      <Chat />
    </>
  );
};

export default EmbedWrapper;
